import * as React from 'react';
import { connect } from 'react-redux';
import * as ReportModule from 'Modules/ReportModule';
import { withTranslation  } from 'react-i18next';
import { ParentDetails, CustomProps, IParentDetailsProps } from 'components/Layout/DetailsSidebar/ParentDetails';
import TerminalInstallationReport from './../Form/TerminalInstallationReportForm';
import { createSerachQuery } from 'Connectors/_main';
interface IP extends IParentDetailsProps {
    history: any;
}
type ConnectedP = {
    reportStore: ReportModule.Types.ReportStore;
};
type DispatchedP = {
    getTerminalInstallationReport: (params: URLSearchParams) => void;
    getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) => void;
    t?: (key: string) => string;
};
type S = {};
class TerminalInstallationReportDetails extends ParentDetails<IP & ConnectedP & DispatchedP, S> {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    public getCustomProps(): CustomProps {
        return {
            ...(this.props as any),
            extrnalRender: () => this.extrnalRender()
        };
    }

    private async handleSubmit(formData: any) {
        const query = { ...formData };
        const { getTerminalInstallationReport } = this.getCustomProps();
        const params = createSerachQuery(query);
        await getTerminalInstallationReport(params);
    }

    private extrnalRender() {
        const { getReportFile, reportStore, t } = this.getCustomProps();
        const { PDF, CSV, XLSX } = ReportModule.EnumTypes.ReportExtension;
        const { TERMINAL_INSTALLATION_REPORT } = ReportModule.EnumTypes.ReportType;
        return (
            <>
                <TerminalInstallationReport
                    onSubmit={this.handleSubmit}
                />
                <div className="report__generate-file">
                    <button disabled={reportStore.terminalInstallationReport === null} className="report__button btn btn--clean" onClick={() => getReportFile(PDF, TERMINAL_INSTALLATION_REPORT)}>
                        <img src={'/images/icons/pdf_icon.svg'} alt="PDF" className="report__button-img"/> <span>{t('exportToPDF')}</span>
                    </button>
                    <button disabled={reportStore.terminalInstallationReport === null} className="report__button btn btn--clean" onClick={() => getReportFile(CSV, TERMINAL_INSTALLATION_REPORT)}>
                        <img src={'/images/icons/csv_icon.svg'} alt="CSV" className="report__button-img"/> <span>{t('exportToCSV')}</span>
                    </button>
                    <button disabled={reportStore.terminalInstallationReport === null} className="report__button btn btn--clean" onClick={() => getReportFile(XLSX, TERMINAL_INSTALLATION_REPORT)}>
                        <img src={'/images/icons/xls_icon.svg'} alt="XLS" className="report__button-img"/> <span>{t('exportToXLS')}</span>
                    </button>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        reportStore: state.reportStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        getTerminalInstallationReport: (params: URLSearchParams) => dispatch(ReportModule.Actions.getTerminalInstallationReport(params)),
        getReportFile: (extension: ReportModule.EnumTypes.ReportExtension, type: ReportModule.EnumTypes.ReportType, params?: URLSearchParams) =>
            dispatch(ReportModule.Actions.getReportFile(extension, type, params)),
    };
}
export default withTranslation ('reports')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(TerminalInstallationReportDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/DetailsSidebar/TerminalInstallationReportDetails.tsx